import * as React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import ProjectSection from 'benchmarking-domain/project-section';

interface DeleteDynamicItemButtonProps {
  projectSection: ProjectSection;
  dynamicItemName: string;
  onDelete: (data: ProjectSection) => Promise<void>;
}

export function DeleteDynamicItemButton({
  projectSection,
  dynamicItemName,
  onDelete,
}: DeleteDynamicItemButtonProps): React.JSX.Element {
  const [openConfirmation, setOpenConfirmation] = React.useState(false);

  const handleDeleteDynamicItem: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    setOpenConfirmation(true);
  };

  const handleClose = async (confirmed: boolean, event?: React.MouseEvent) => {
    event?.stopPropagation();

    if (confirmed) {
      const dynamicItems = projectSection?.dynamicItems
        ? [...projectSection.dynamicItems.filter((i) => i !== dynamicItemName)]
        : [];

      await onDelete({ ...projectSection, dynamicItems });
    }

    setOpenConfirmation(false);
  };

  return (
    <>
      <Button
        type="button"
        variant="text"
        size="small"
        color="secondary"
        sx={{ padding: '1px 12px', marginRight: 2 }}
        onClick={handleDeleteDynamicItem}
      >
        Delete
      </Button>
      <Dialog
        open={openConfirmation}
        onClose={(e) => handleClose(false, undefined)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete {dynamicItemName}?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this item? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => handleClose(false, e)}>Disagree</Button>
          <Button variant="contained" color={'warning'} onClick={async (e) => await handleClose(true, e)} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
